import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.6_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/catering/catering-form.tsx");
